export enum SummaryFormular{
  OnSite = 1,
  OffSite = 2,
  RosterCode = 3  
}